import React, { Fragment } from 'react';
import { Container, Row } from 'reactstrap';
import { Breadcrumbs } from '../../../../AbstractElements';
import LeaseEdit from './LeaseEdit';

const EditLease = () => {
    return (
        <Fragment>
            <Breadcrumbs mainTitle='View Tenant Lease Detail' parent='Tenant' title='Lease Edit' />
            <Container fluid={true}>
                <div className='edit-profile'>
                    <Row>
                        <LeaseEdit />
                    </Row>
                </div>
            </Container>
        </Fragment>
    )
}

export default EditLease